import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { AssetEditorProps } from "./AssetEditor";
const AssetEditor = lazy(() => import("./AssetEditor").then(module => ({ default: module.AssetEditor })));
import "./asset-editor.css";

export function mountAssetEditor(slot: HTMLElement, session: number, props: AssetEditorProps) {
  setStudioView("drawer", "asset-editor", <AssetEditor key={`${props.assetId}:${session}`} {...props} />);
}
